const $ = jQuery.noConflict();
'use strict';
const UsersList = {
	init: function () {
		if ($('body.users-php').length > 0) {
			$('.wp-list-table span a.resetpassword').hide();
		}
		if ($('body.users-php').length > 0) {
			$('.wp-list-table span.view a').hide();
		}
	}
};

export default UsersList;
